var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMembershipCrownDisabled = function SvgMembershipCrownDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9268 16.84H3.83936C3.27868 16.84 2.78994 16.4584 2.65398 15.9145L0.0365033 5.44447C-0.0791667 4.98155 0.0851342 4.49362 0.457396 4.19507C0.829576 3.89637 1.34154 3.84195 1.76838 4.05529L5.99131 6.16676L9.33547 0.593175C9.55631 0.225149 9.95398 0 10.3832 0C10.8124 0 11.2101 0.22523 11.4309 0.593175L14.7751 6.16676L18.9981 4.05529C19.4246 3.84187 19.9366 3.89637 20.309 4.19507C20.6812 4.49362 20.8456 4.98155 20.7299 5.44447L18.1123 15.9145C17.9763 16.4584 17.4875 16.84 16.9268 16.84Z",
    fill: "#AFC4FF"
  })));
};
export default SvgMembershipCrownDisabled;